// The AirBridge wordmark and tagline, in ONE place.
//
// FD-ADR-043 D1 locks all three: the blue letter mark (no orange), the wordmark
// spelled **AirBridge** — camel-case, as every mockup screen and the login page
// render it, not the lower-case "Airbridge" of the print logo assets — and the
// tagline in caps.
//
// They live here rather than inline in the rail and the login so a rename is one
// edit and cannot half-apply. That is the FD-270 lesson: FD-236 inverted a rule,
// three documents were corrected, and four in-code statements of the old rule
// still survived.

export const WORDMARK = 'AirBridge';
export const TAGLINE = 'DEVICE MIGRATION BY GETRUBIX';

/** What the mark's accessible name should say when it is the only brand element. */
export const BRAND_LABEL = `${WORDMARK} — go to the workspace`;
